import {z} from "zod"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            sourceImage: anyImageOpResult,
        }),
    },
}
